var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M0,12v24h25l23-24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.5,18H23v7v2v0.5L19.2,18h-3.5l-3.088,7.883c-0.405-1.752-2.259-2.417-3.412-2.683C6.2,22.4,6,22,6,21.4c0-1.5,4-0.8,5-0.4c0.3-0.8,0.9-2.3,0.9-2.3S10.8,18,7.4,18C4,18,3,20.1,3,21.4c0,1.3,0.7,2.8,2.6,3.4c2,0.6,3.5,0.7,3.5,1.7s-3.4,1.2-5.3,0L3,29.1c0,0,1.1,0.9,4.4,0.9c1.781,0,3.167-0.503,4.08-1.226L11,30h3.5l0.6-1.8c0.7,0.3,1.5,0.5,2.4,0.5s1.7-0.2,2.4-0.5l0.6,1.8H23h1h2v-3h1.5c2.5,0,4.5-2,4.5-4.5S30,18,27.5,18z M17.5,26.1c-0.6,0-1.1-0.1-1.5-0.4l1.5-4.3l1.5,4.3C18.6,26,18.1,26.1,17.5,26.1z M27.5,24H26v-3h1.5c0.8,0,1.5,0.7,1.5,1.5S28.3,24,27.5,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.5da4818afb6936e0d69a374b0f8ccc76.svg";
export { ForwardRef as ReactComponent };